import { defineComponent, type PropType, type VNodeChild } from 'vue'

/** Preserve VNodes returned by render APIs; interpolation would turn them into text. */
export default defineComponent({
  name: 'RrRenderContent',
  props: { value: { type: null as unknown as PropType<VNodeChild> } },
  setup: props => () => props.value
})
